import { useEffect } from 'react';
import { useAuth } from '../auth';
import { usePageTitle } from '../hooks/usePageTitle';

export default function LoginPage() {
  const { login, isLoading } = useAuth();
  usePageTitle('Sign in');

  useEffect(() => {
    if (!isLoading) login();
  }, [isLoading, login]);

  return (
    <div className="not-configured" style={{ textAlign: 'center' }}>
      <h1 style={{ marginTop: 0 }}>bevi-ailab</h1>
      <p className="muted">Redirecting to sign in...</p>
      <button type="button" data-testid="login-button" onClick={() => login()}>
        Sign in
      </button>
    </div>
  );
}
